import React from 'react';
import composeClassNames from 'utils/composeClassNames';
import Button from '../../components/library/Button/Button';
import TextInput from '../../components/library/Input/TextInput/TextInput';
import PasswordInput from '../../components/library/Input/PasswordInput';

function LoginForm({ onShowForgotPasswordForm, targetPath }) {
  return (
    <div>
      <h1 className={composeClassNames(['Login__formTitle'])}>
        {trovitApp.i18n('the_traffic_adcquisition_tool')}
      </h1>
      <p className="Login__formSubtitle">
        {trovitApp.i18n('buy_optimize_traffic_in_trovit_mitula')}
      </p>
      <form method="POST" className="Login__form" action="/cod.login">
        <TextInput name="email" color="thribee-yellow" label="Email" required />
        <PasswordInput name="password" required />
        <input
          type="hidden"
          name="_target_path"
          value={targetPath ?? '/cod.campaigns_performance'}
        />
        <Button color="thribee-yellow" variant="flat" type="submit">
          {trovitApp.i18n('login')}
        </Button>
        <a
          className={composeClassNames(['Login__Link'])}
          href="/"
          onClick={(e) => {
            e.preventDefault();
            onShowForgotPasswordForm();
          }}
        >
          {trovitApp.i18n('login_forgotten_password_title')}
        </a>
      </form>
    </div>
  );
}

export default LoginForm;
